import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
import Link from 'flarum/common/components/Link';
import LogInModal from 'flarum/forum/components/LogInModal';
import { icon } from './ui';
export default class Shoutbox extends Component {
  messages = [];
  draft = '';
  loading = true;
  sending = false;
  error = '';
  oninit(vnode) {
    super.oninit(vnode);
    this.load();
    this.timer = window.setInterval(() => this.load(false), 10000);
  }

  // Kontrolki moderacji są dostępne w PA; nie opieramy startu forum na
  // usuniętym w Flarum 2 RC extenderze serializatora.
  canModerate() {
    return false;
  }
  async moderate(entry, action) {
    const content = action === 'edit' ? window.prompt('Nowa treść wiadomości:', entry.message) : undefined;
    if (action === 'edit' && (content === null || !content.trim())) return;
    const reason = window.prompt('Powód operacji (widoczny w dzienniku):', '') ?? '';
    try {
      await app.request({
        method: 'POST',
        url: `${String(app.forum.attribute('apiUrl') || '/api').replace(/\/$/, '')}/nova/moderation/messages/${entry.id}`,
        body: {
          action,
          message: content,
          reason
        }
      });
      await this.load(false);
    } catch (error) {
      this.error = error?.response?.errors?.[0]?.detail || 'Operacja moderacyjna nie powiodła się.';
    }
    m.redraw();
  }
  onremove() {
    if (this.timer) window.clearInterval(this.timer);
  }
  endpoint() {
    return `${String(app.forum.attribute('apiUrl') || '/api').replace(/\/$/, '')}/nova/shoutbox`;
  }
  async load(redraw) {
    if (redraw === void 0) {
      redraw = true;
    }
    try {
      const response = await app.request({
        method: 'GET',
        url: this.endpoint()
      });
      this.messages = Array.isArray(response?.messages) ? response.messages : [];
      this.error = '';
    } catch {
      this.error = 'Czat jest chwilowo niedostępny.';
    } finally {
      this.loading = false;
      if (redraw) m.redraw();
    }
  }
  async send(event) {
    event.preventDefault();
    const message = this.draft.trim();
    if (!message || this.sending) return;
    this.sending = true;
    this.error = '';
    try {
      await app.request({
        method: 'POST',
        url: this.endpoint(),
        body: {
          message
        }
      });
      this.draft = '';
      await this.load(false);
    } catch (error) {
      this.error = error?.response?.errors?.[0]?.detail || 'Nie udało się wysłać wiadomości.';
    } finally {
      this.sending = false;
      m.redraw();
    }
  }
  view() {
    const loggedIn = Boolean(app.session.user);
    return m("section", {
      className: "NtCard NtShoutbox",
      id: "shoutbox"
    }, m("header", null, m("div", null, m("small", null, "FORUM + MTA + DISCORD"), m("strong", null, "NovaChat")), m("button", {
      type: "button",
      "aria-label": "Od\u015Bwie\u017C czat",
      onclick: () => this.load()
    }, icon('fas fa-sync-alt'))), m("div", {
      className: "NtShoutbox-messages"
    }, this.loading ? m("span", {
      className: "NtShoutbox-empty"
    }, "\u0141adowanie wiadomo\u015Bci\u2026") : null, !this.loading && !this.messages.length ? m("span", {
      className: "NtShoutbox-empty"
    }, "Napisz pierwsz\u0105 wiadomo\u015B\u0107.") : null, this.messages.map(entry => {
      const name = m("strong", null, entry.username);
      return m("article", {
        key: entry.id
      }, m("div", null, entry.profile_slug ? m(Link, {
        href: `/u/${encodeURIComponent(entry.profile_slug)}${entry.platform !== 'forum' ? '/gracz' : ''}`
      }, name) : name, m("span", {
        className: `NtShoutbox-platform is-${entry.platform}`
      }, entry.platform === 'mta' ? 'MTA' : entry.platform === 'discord' ? 'DISCORD' : 'FORUM')), m("p", null, entry.message), m("footer", null, entry.edited_at ? m("small", null, "edytowano") : null, this.canModerate() ? m("span", {
        className: "NtShoutbox-tools"
      }, m("button", {
        type: "button",
        onclick: () => this.moderate(entry, 'edit')
      }, icon('fas fa-pen')), m("button", {
        type: "button",
        onclick: () => this.moderate(entry, 'delete')
      }, icon('fas fa-trash'))) : null));
    })), this.error ? m("div", {
      className: "NtShoutbox-error"
    }, this.error) : null, loggedIn ? m("form", {
      onsubmit: event => this.send(event)
    }, m("input", {
      maxlength: "240",
      value: this.draft,
      placeholder: "Napisz wiadomo\u015B\u0107\u2026",
      oninput: event => this.draft = event.target.value
    }), m("button", {
      type: "submit",
      disabled: this.sending || !this.draft.trim(),
      "aria-label": "Wy\u015Blij"
    }, icon('fas fa-paper-plane'))) : m("button", {
      className: "NtShoutbox-login",
      type: "button",
      onclick: event => {
        event.preventDefault();
        app.modal.show(LogInModal, {});
      }
    }, icon('fas fa-sign-in-alt'), " Zaloguj si\u0119, aby pisa\u0107"));
  }
}
flarum.reg.add('novatruck-theme', 'forum/components/Shoutbox', Shoutbox);